template.main_search = function() {
	var modalOptions = {
		ID: '#search-site-overlay',
		focusOpen: '#main-search-form__input',
	};

	$('.main-search, .main-search-mobile').on({
		'click': function() {
			var closedElemClass = '.' + $(this).attr("class").split(' ').join('.');

			$('#search-site-overlay').attr('data-close-focus', closedElemClass);

			modalService.open(modalOptions.ID, modalOptions.focusOpen, closedElemClass);
		}
	});

	$('.search-overlay__close-btn').on({
		'click': function() {
			var closedElemClass = $('#search-site-overlay').attr('data-close-focus');

			modalService.close(modalOptions.ID, closedElemClass);
		}
	});

	$('.btn--search').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.main-search').trigger('click');
	});

	$('body').on({
		'click': function(e) {
			if(
				(!$('.main-search, .main-search-mobile').is(e.target) && !$('.main-search, .main-search-mobile').has(e.target).length) &&
				(!$('.main-search-panel').is(e.target) && !$('.main-search-panel').has(e.target).length)
			) {
				removeClasses();
			}
		}
	});

	function removeClasses() {
		$('.main-search, .main-search-mobile').removeClass('active');
		$('.main-search-panel').removeClass('active');
		$('.main-search__text, .main-search-mobile__text').text('Search');
		$('.main-search-panel .main-search-form__input').blur();
	}
};
